import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './plugins';
import './directives';
import store from './store';
import { sync } from 'vuex-router-sync';
import '@/styles/index.scss';

Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = false;

sync(store, router);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
